// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3BT-i","wrapper":"_3KrDc","text":"_2MA3N","table-content":"cJde1","table-heading":"_1e4D4","table-data":"_3ZP8U","border":"_3DMMX"};